import React from 'react';
import ViewerContainer from 'containers/ViewerContainer';

const Viewer = () => {
    return <ViewerContainer />;
};

export default Viewer;
